import { Form, Input } from 'antd'
import { useEffect, useRef } from 'react'
import { ButtonCommon } from '..'

const TextArea = Input.TextArea

export const FormSingleField = ({
	initialValue = '',
	label = '',
	fieldName,
	isRequired,
	onSubmit,
}) => {
	const inputRef = useRef()
	const [form] = Form.useForm()

	useEffect(() => {
		inputRef.current.focus()
	}, [])

	useEffect(() => {
		form.setFieldValue({ [fieldName]: initialValue })
		inputRef.current.resizableTextArea.textArea.value = initialValue
		setTimeout(() => {
			inputRef.current.focus()
		}, 200)
	}, [initialValue, form, fieldName])

	const handleSubmit = async () => {
		const values = await form.validateFields()

		onSubmit(values[fieldName].trim())
	}

	// const handleKeyDown = e => {
	// 	if (e.keyCode === KEY_CODE.ENTER) {
	// 		handleSubmit()
	// 	}
	// }

	return (
		<Form
			form={form}
			initialValues={{
				[fieldName]: initialValue,
			}}
		>
			<Form.Item
				key="name"
				label={label}
				name={fieldName}
				rules={
					isRequired
						? [
								{
									required: true,
									message: 'Please enter value',
								},
						  ]
						: []
				}
			>
				<TextArea
					ref={inputRef}
					placeholder={`Enter ${label.toLowerCase()}`}
				/>
			</Form.Item>

			<div className="u-row-right">
				<ButtonCommon onClick={handleSubmit} type="primary">
					Save
				</ButtonCommon>
			</div>
		</Form>
	)
}
